import type { LucideIcon } from 'lucide-react';
import { Warehouse, Send } from 'lucide-react';

export type AddonId = 'warehouse' | 'newsletter';

export interface AddonLockContent {
  id: AddonId;
  /** Nome della sezione come appare in sidebar: è la voce che l'utente ha appena cliccato. */
  title: string;
  /** Cosa fa il modulo, in una riga. */
  description: string;
  /** 3-4 capacità concrete, non claim di marketing. */
  features: string[];
  /** Icona Lucide: la stessa usata dalla voce di menu in menuConfig.ts. */
  icon: LucideIcon;
  /** `subscription_addons.addon_group` — il prezzo si legge da lì, mai hardcoded. */
  addonGroup: string;
  /** Testo del bottone primario. */
  ctaPrimary: string;
  /** Prefill del messaggio WhatsApp per la demo. */
  demoMessage: string;
}

export const ADDON_LOCK_CONTENT: Record<AddonId, AddonLockContent> = {
  warehouse: {
    id: 'warehouse',
    title: 'Magazzino',
    description:
      'Prodotti, scorte, movimenti e DDT dentro Flusia, collegati ai clienti e alle offerte che gestisci già.',
    features: [
      'Anagrafica prodotti illimitata, con varianti e attributi',
      'Movimenti di carico e scarico con tracciabilità',
      'DDT, fatture elettroniche e riassortimento automatico',
      'Sincronizzazione bidirezionale delle giacenze con WooCommerce',
    ],
    icon: Warehouse,
    addonGroup: 'warehouse',
    ctaPrimary: 'Attiva Magazzino',
    demoMessage: 'Vorrei una demo del modulo Magazzino di Flusia',
  },
  newsletter: {
    id: 'newsletter',
    title: 'Newsletter',
    description:
      'Campagne email verso le liste che nascono dai dati del CRM, con il tracciamento dei risultati nella scheda di ogni contatto.',
    features: [
      'Editor drag and drop, senza scrivere HTML',
      'Liste segmentate da stato cliente, tag e interessi',
      'Tracciamento di aperture, click e disiscrizioni',
      'Statistiche e test A/B per ogni invio',
    ],
    icon: Send,
    addonGroup: 'newsletter',
    ctaPrimary: 'Attiva Newsletter',
    demoMessage: 'Vorrei una demo delle Campagne email di Flusia',
  },
};
